import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import './styles.less'

class TripCard extends React.Component {
	componentWillMount() {
	
	}

	render() {
		const start    = moment(this.props.trip.departureTime).format('HH:mm')
		const end      = moment(this.props.trip.arrivalTime).format('HH:mm')
		const duration = moment.duration(this.props.trip.duration, 'minutes').humanize()

		return (
			<div className="trip-card">
				<time>{start} <i> ⟶ </i> {end}</time>

				<strong title={`${this.props.trip.prices[1]}`} >
					{this.props.trip.prices[0]}
				</strong>

				<p>{this.props.trip.from} - {this.props.trip.to}</p>
				<p>Duration: {duration}</p>
			</div>
		)
	}
}

TripCard.propTypes = {
	trip: PropTypes.object.isRequired,
}

export default TripCard


// WEBPACK FOOTER //
// ./src/components/FligthsTable/TripCard/index.js